import moment from 'moment'

export const formatTime = (time: number, format?: string): string => {
    return moment(time).format(format || 'LLL')
}
